import { render, staticRenderFns } from "./MarkdownCkComponent.vue?vue&type=template&id=2a71e9f2&scoped=true&"
import script from "./MarkdownCkComponent.vue?vue&type=script&lang=js&"
export * from "./MarkdownCkComponent.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownCkComponent.vue?vue&type=style&index=0&id=2a71e9f2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a71e9f2",
  null
  
)

export default component.exports